/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import React from 'react';
import parse from 'html-react-parser';
import { Element, Text } from 'domhandler';
import {Latex} from "./Latex";
import {Grl} from "./Grl";

interface WikitextProps {
    wikitext: string;
}

export const Wikitext: React.FC<WikitextProps> = React.memo(({ wikitext }) => {
    return (
        <>
            {parse(wikitext, {
                replace: (domNode) => {
                    if (domNode.type === 'tag') {
                        const domNodeElement = domNode as Element;
                        if (domNodeElement.name === 'ltx' && domNodeElement.children.length !== 0 && domNodeElement.children[0].type === 'text') {
                            return <Latex>{(domNodeElement.children[0] as Text).data}</Latex>;
                        }

                        if (domNodeElement.name === 'grl' && domNodeElement.children.length !== 0 && domNodeElement.children[0].type === 'text') {
                            return <Grl>{(domNodeElement.children[0] as Text).data}</Grl>;
                        }
                    }
                },
            })}
        </>
    );
});
